"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendMessageBack;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendMessageBack() {
  return (0, _useWebChatAPIContext.default)().sendMessageBack;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kTWVzc2FnZUJhY2sudHMiXSwibmFtZXMiOlsidXNlU2VuZE1lc3NhZ2VCYWNrIiwic2VuZE1lc3NhZ2VCYWNrIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxrQkFBVCxHQUF5RjtBQUN0RyxTQUFPLHFDQUF1QkMsZUFBOUI7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZW5kTWVzc2FnZUJhY2soKTogKHZhbHVlOiBhbnksIHRleHQ/OiBzdHJpbmcsIGRpc3BsYXlUZXh0Pzogc3RyaW5nKSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2VuZE1lc3NhZ2VCYWNrO1xufVxuIl19